import React, { FC } from 'react';
import { DragDropContext } from 'react-virtualized-dnd';
import { toastService } from 'components/molecules/toast';
import { useTranslation } from 'hooks/use-translation';
import { logger } from 'services';
import { queueMacrotask } from 'utils/macrotask';
import { updateMatrix } from './actions';
import { BoardOrchestrator } from './board-orchestrator';
import { useBoardContext } from './context';
import { BoardProps, DropEndResult, DropLocation } from './types';
import { parseDraggableId } from './utils';

export const BoardInner: FC<BoardProps> = ({
  swimlanes = [],
  columns = [],
  onChange,
  size,
  onCreate,
  disableCrossDrop,
  currentProjectId,
  isColumnHidden,
}) => {
  const { dispatch } = useBoardContext();

  const title = useTranslation('kanban.error.drop_not_allowed.title');
  const message = useTranslation('kanban.error.drop_not_allowed.message');

  const onDragStart = () => {
    // dispatch(dragStart(event));
    logger.log('drag start');
  };

  function onDragEnd(
    draggedElem: DropLocation,
    droppableActive: string,
    placeholder: string /* , targetSection */,
  ) {
    logger.log('drag end');
    const result: DropEndResult = {
      source: draggedElem,
      destination: {
        droppableId: droppableActive,
        draggableId: placeholder,
      },
    };
    const [sourceRowId] = parseDraggableId(draggedElem.droppableId);
    const [destinationRowId, destinationColumnId] =
      parseDraggableId(droppableActive);

    if (disableCrossDrop && sourceRowId !== destinationRowId) {
      logger.log('drop not allowed');
      toastService({
        title,
        message,
      }).error();

      return;
    }
    const destinationColumn = columns.find(
      (col) => col.colId === destinationColumnId,
    );

    if (destinationColumn && destinationColumn.isDropDisabled) {
      logger.log('drop not allowed');
      toastService({
        title,
        message: '',
      }).error();

      return;
    }
    dispatch(updateMatrix(result));
    queueMacrotask(() => onChange(result));
  }

  function onDragCancel(...args) {
    logger.log('drag cancel', args);
  }

  return (
    <DragDropContext
      dragAndDropGroup="name1"
      onDragEnd={onDragEnd}
      onDragCancel={onDragCancel}
      onDragStart={onDragStart}
      outerScrollBar
      scrollContainerHeight={size.height}
    >
      <BoardOrchestrator
        swimlanes={swimlanes}
        columns={columns}
        size={size}
        onCreate={onCreate}
        currentProjectId={currentProjectId}
        isColumnHidden={isColumnHidden}
      />
    </DragDropContext>
  );
};
